export const cards = [
  {
    id: "a03bc7e7-c40c-48fc-b175-44fb9572b6cb",
    type: "bridge",
    img: "/cards-img/bridge-card.svg",
    name: "Как строят мосты над водой?",
    delay: 0.35,
    img1: "/cards-page-img/bridge-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "Планирование и чертежи",
      },
      {
        type: "paragraph",
        content:
          "Всё начинается с плана. Инженеры изучают реку: её глубину, скорость течения и даже рыбу в воде. Они делают чертежы на компьютерах или на бумаге. Главное — обеспечить его надежность: мост должен выдерживать вес машин и напор ветра. Часто для проверки расчётов инженеры создают миниатюрные модели.",
      },
      {
        type: "media-block",
        direction: "column-reverse",
        img: "/cards-page-img/bridge-img-2.jpg",
        title: "Фундамент",
        text: "Мост не может висеть в воздухе - ему нужны опоры. Сначала строители осушают участок дна реки, где будут ставить сваи. Они строят временные стены (дамбы) вокруг места работы, как большой бассейн, и откачивают воду насосами. Теперь дно сухое, и можно работать без погружения в воду! Потом вбивают сваи - длинные железные столбы - глубоко в грунт с помощью мощных машин. Если грунт мягкий, заливают бетон вокруг свай для прочности. Всё укрепляют, чтобы мост не качался от волн.",
      },
      {
        type: "media-block",
        direction: "column-reverse",
        img: "/cards-page-img/bridge-img-3.jpg",
        title: "Опоры и пролёты",
        text: "На сваях возводят опоры - высокие бетонные или стальные башни. Потом устанавливают пролёты - секции дороги между опорами. Для простых мостов пролёты кладут как балки: поднимают готовые плиты кранами и укладывают на опоры. Для длинных - используют подвесные системы: натягивают тросы между башнями и подвешивают к ним пролёты. Части часто собирают на берегу и сдвигают на место гидравликой, или поднимают прямо с барж по реке. Всё соединяют и мост почти готов.",
      },
      {
        type: "title",
        content: "Финальные штрихи: безопасность и красота",
      },
      {
        type: "paragraph",
        content:
          "Когда с основой закончили, добавляют дорогу, ограждения и освещение. Проверяют на прочность: машины ездят по мосту, чтобы убедиться, что он не трясётся. Добавляют антикоррозийные покрытия, чтобы вода не разъела металл. В итоге мост становится не только полезным, но и красивым. Знаете ли вы, что самый длинный мост в мире это Даньян-Куньшань в Китае, длиной 164 километра? Он как змея, ползущая по морю.",
      },
      {
        type: "ending",
        content: "Хотели бы протестировать прочность моста первыми?",
      },
    ],
  },
  {
    id: "526a6e8e-c285-457a-be8c-f4acda92bc2a",
    type: "flamingo",
    img: "/cards-img/flamingo-card.svg",
    name: "Почему фламинго розовые?",
    delay: 0.35,
    img1: "/cards-page-img/flamingo-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "Почему фламинго розовые?",
      },
      {
        type: "paragraph",
        content:
          "Если вы думаете, что фламинго рождаются розовыми, вы ошибаетесь! Птенцы фламинго появляются на свет пушистыми и совершенно белыми или серыми. Их знаменитый розовый цвет — это не подарок природы, а результат их необычной диеты.",
      },
      {
        type: "title",
        content: "Всё дело в еде!",
      },
      {
        type: "paragraph",
        content:
          "Фламинго питаются мелкими водорослями и личинками, которые богаты особыми натуральными пигментами — <strong class='bold-word'>каротиноидами</strong>. Именно эти пигменты придают оранжевый цвет моркови и красный цвет помидорам.",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/flamingo-img-2.jpg",
        title: "",
        text: "Представьте, что фламинго постоянно ест «краситель», который содержится в его пище. Печень птицы перерабатывает эти пигменты, а затем они попадают в перья, клюв и ноги, окрашивая их в нежные розовые, оранжевые или ярко-красные оттенки.",
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/flamingo-img-3.jpg",
        title: "Что будет, если фламинго перестанет есть эту пищу?",
        text: "Если в зоопарке фламинго не будут получать специальный корм с каротиноидами (например, креветок или добавки с морковью и свеклой), их перья постепенно поблекнут и станут снова белыми.",
      },
      {
        type: "paragraph-heart",
        content:
          "Так что их розовый цвет — это как индикатор здоровья и доказательство того, что они хорошо питаются. Это цвет их изысканного вкуса!",
      },
    ],
  },
  {
    id: "9e7df0e7-50fb-4174-92f0-6de9018d9b23",
    type: "cinema-special-effects",
    img: "/cards-img/cinema-card.svg",
    name: "Как устроены спецэффекты в кино?",
    delay: 0.05,
    img1: "/cards-page-img/cinema-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "А вы знаете, как делают спецэффекты в кино?",
      },
      {
        type: "paragraph",
        content:
          "Представьте себе: на экране величественный дракон сжигает целый город, Капитан Америка метнул свой щит прямо в вашу сторону, а герои «Аватара» прыгают по парящим в небе горам. За всем этим стоит не магия, а удивительные технологии, хитрости и огромные усилия. Давайте разберемся, как это работает!",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/cinema-img-2.jpg",
        title: "Когда всё по-настоящему: Практические эффекты.",
        text: "Представьте, что в фильме нужно поджечь машину или взорвать здание. Это действительно делают! Но, конечно, всё происходит безопасно и под контролем.",
      },
      {
        type: "list",
        style: "point",
        items: [
          "<strong class='bold-word'>Фейерверки и взрывы</strong> — используют специальные смеси, которые имитируют огонь и дым, но при этом безопасны.",
          "<strong class='bold-word'>Грим и протезы</strong> — превращают актеров в монстров, зомби или инопланетян. Например, Орки из «Властелина колец» — это в основном актеры в гриме!",
          "<strong class='bold-word'>Каскадерские трюки</strong> — иногда проще и эффектнее снять настоящий прыжок с крыши, чем рисовать его на компьютере.",
        ],
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/cinema-img-3.jpg",
        title: "Компьютерная графика.",
        text: "Но когда дело доходит до драконов, космоса и огромных армий, без компьютеров не обойтись.",
      },
      {
        type: "list",
        style: "point",
        items: [
          "<strong class='bold-word'>Захват движения</strong> — актеры надевают специальные костюмы с датчиками, и их движения переносятся на цифровых персонажей (как в «Аватаре»).",
          "<strong class='bold-word'>Зеленый экран</strong> — позволяет добавлять фантастические пейзажи.",
          "<strong class='bold-word'>3D-моделирование</strong> — создаются целые города и существа, которых не существует в реальности. Например, в «Человеке-пауке» некоторые здания и сражения полностью цифровые, но выглядят как настоящий Нью-Йорк!",
        ],
      },
      {
        type: "title",
        content: "Фокусы камеры: оптические иллюзии.",
      },
      {
        type: "paragraph",
        content:
          "Иногда достаточно просто обмануть зрителя. Например, чтобы Хоббиты во «Властелине колец» выглядели меньше людей, актеры просто становились ближе или дальше от камеры!",
      },
      {
        type: "list",
        style: "hand-point",
        customHeader:
          "Так что в следующий раз, когда будете смотреть фильм, <strong class='bold-word'>обратите внимание</strong> на:",
        items: [
          "Что здесь сделано на самом деле?",
          "Какие эффекты созданы с помощью компьютера?",
          "Как они обманули ваш мозг?",
        ],
      },
      {
        type: "ending",
        content: "Какой спецэффект из кино впечатлил вас больше всего?",
      },
    ],
  },
  {
    id: "e22c268d-4369-4b0e-8c26-3f987c110321",
    type: "lego",
    img: "/cards-img/lego-card.svg",
    name: "Как устроено производство кирпичиков лего?",
    delay: 0.1,
    img1: "/cards-page-img/lego-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "Производство кирпичиков LEGO: от сырья до готового продукта.",
      },
      {
        type: "paragraph",
        content:
          "Я думаю, что почти все знают о кирпичиках LEGO, но не все знают, как их делают. Поэтому эта статья именно для вас! Давайте вместе отправимся в увлекательное путешествие по фабрике LEGO и узнаем, как создаются эти знаменитые кубики.",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/lego-img-2.jpg",
        title: "Подготовка сырья",
        text: "Всё начинается с маленьких пластиковых гранул, которые представляют собой прочный и безопасный пластик. Эти гранулы засыпаются в огромные «миксеры», где они нагреваются до 230°C и превращаются в «пластиковое тесто».",
      },
      {
        type: "title",
        content: "Формование деталей.",
      },
      {
        type: "paragraph",
        content:
          "Затем расплавленный пластик попадает в пресс-формы, которые создают фирменные кубики с пупырками и отверстиями. Машины работают с невероятной точностью — погрешность меньше толщины человеческого волоса!",
      },
      {
        type: "title",
        content: "Контроль качества.",
      },
      {
        type: "paragraph",
        content: "После формования каждый кубик проходит строгие испытания:",
      },
      {
        type: "list",
        style: "point",
        items: [
          "Проверяется соединение деталей",
          "Тестируется прочность (качественный кубик выдерживает до 50 кг)",
          "Проверяются безопасность краев",
        ],
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/lego-img-3.jpg",
        title: "Окрашивание",
        text: "Затем наступает время цвета — детали окрашиваются в яркие, стойкие оттенки. Используемая краска не выцветает даже после 1000 часов на солнце!",
      },
      {
        type: "title",
        content: "Упаковка и доставка.",
      },
      {
        type: "paragraph",
        content:
          "Перед упаковкой кубики охлаждают и сушат, затем их раскладывают в яркие коробки и отправляют на стойки в магазины по всему миру!",
      },
      {
        type: "list",
        style: "hand-point",
        customHeader: "<strong class='bold-word'>Интересные факты:</strong>",
        items: [
          "Каждую минуту производится 100 000 деталей!",
          "Существует более 17 000 видов деталей",
          "Деталей, сделанных за год, хватит, чтобы 10 раз обернуть Землю!",
        ],
      },
      {
        type: "ending",
        content:
          "Теперь вы знаете, какой удивительный путь проходит каждый кубик LEGO прежде, чем попасть к вам в руки. В следующий раз, собирая конструктор, попробуйте представить себе этот захватывающий процесс!",
      },
    ],
  },
  {
    id: "8b6ccf70-34fe-4590-bea7-f52f789ddf23",
    type: "plant",
    img: "/cards-img/plant-card.svg",
    name: "Кто такая Венерина мухоловка?",
    delay: 0.15,
    img1: "/cards-page-img/plant-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "Кто такая Венерина мухоловка?",
      },
      {
        type: "paragraph",
        content:
          "Помните растение под названием «Чомпер» из игры «Plants vs Zombies», которое проглатывало зомби? Так вот, Венерина мухоловка совсем не большая и не ест зомби, но не откажется от парочки насекомых. Это удивительное растение можно встретить в болотах США, особенно в Северной и Южной Каролине.",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/plant-img-3.jpg",
        title: "Как устроено растение?",
        text: "У Венериной мухоловки короткий стебель, на котором растут ловушки, похожие на челюсти с зубчиками по краям. Эти 	«челюсти» закрываются, когда на них попадает добыча.",
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/plant-img-2.jpg",
        title: "Как работает ловушка?",
        text: "На листьях расположены чувствительные волоски. Если насекомое касается одного из них, и в течение 20 секунд срабатывает второй волосок, «челюсти» захлопнутся, удерживая жертву. После этого начинается процесс переваривания, который длится около 10 дней. Растение выделяет специальный сок, чтобы извлечь питательные вещества из насекомых.",
      },
      {
        type: "title",
        content: "Почему Венерина мухоловка важна?",
      },
      {
        type: "paragraph",
        content:
          "Венерина мухоловка играет важную роль в экосистеме, помогая контролировать популяцию насекомых. К сожалению, из-за разрушения среды обитания это удивительное растение находится под угрозой исчезновения. Поэтому важно защищать такие уникальные виды, чтобы они могли продолжать удивлять нас своими особенностями.",
      },
      {
        type: "ending",
        content: "Хотели бы себе такую?",
      },
    ],
  },
  {
    id: "2b4ab0aa-c808-4abb-b4f4-09f53cd8cb05",
    type: "F1-car",
    img: "/cards-img/car-card.svg",
    name: "Как устроен болид F1?",
    delay: 0.2,
    img1: "/cards-page-img/car-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "Болид Формулы-1: как устроена самая быстрая машина в мире.",
      },
      {
        type: "paragraph",
        content:
          "Когда вы видите эти разноцветные болиды, проносящиеся по трассе, знаете ли вы, какая мощь скрыта в них? Они могут разгоняться до 350 км/ч за несколько секунд и проходить повороты быстрее, чем вы успеете моргнуть! Давайте разберёмся, как они это делают.",
      },
      {
        type: "title",
        content: "Крылья и воздух: как болид «летает» по земле.",
      },
      {
        type: "paragraph",
        content:
          "Обычные машины просто разгоняются, а болид Формулы-1 использует воздух, чтобы становиться ещё быстрее. У него есть <strong class='bold-word'>переднее антикрыло</strong> и <strong class='bold-word'>заднее антикрыло</strong> — они не просто для красоты! Они давят на машину, прижимая её к дороге сильнее, чем гравитация. Чем быстрее едет болид, тем крепче он держится за асфальт. Благодаря этому он может входить в повороты на бешеной скорости, не срываясь в занос. ",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/car-img-2.jpg",
        title: "Сердце болида: двигатель с космическими технологиями",
        text: "Он маленький (всего 1,6 литра), но мощный, как 10 обычных машин вместе взятых! А ещё он <strong class='bold-word'>гибридный</strong> — работает не только на бензине, но и использует электричество. Когда пилот ускоряется, двигатель ревёт так громко, что без защиты для ушей гонщики могли бы даже оглохнуть!",
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/car-img-3.jpg",
        title: "Шины: «обувь» для колёс",
        text: "Они не похожи на шины обычных машин — они мягкие, липкие и нагреваются до 100°C во время гонки! Без разогрева они скользят, как лёд, поэтому пилоты специально разогревают их на прогревочном круге. Также . И самое удивительное — даже при такой скорости они остаются целыми!",
      },
      {
        type: "title",
        content: "Безопасность: как защищают гонщиков.",
      },
      {
        type: "paragraph",
        content:
          "Несмотря на огромные скорости, современные болиды почти неуязвимы:",
      },
      {
        type: "list",
        style: "hand-point",
        items: [
          "<strong class='bold-word'>Карбоновый «кокон»</strong> вокруг пилота выдерживает удар мощнее, чем падение с 10-го этажа!",
          "<strong class='bold-word'>Титановая дуга Halo</strong> над кабиной спасает от перевёртываний",
          "<strong class='bold-word'>Костюм пилота</strong> не загорается даже в огне!",
        ],
      },
      {
        type: "ending",
        content: "Погоняли бы?",
      },
    ],
  },
  {
    id: "add0eb8b-8b5e-44b1-ad43-3306f660c9f3",
    type: "cloud-machine",
    img: "/cards-img/cloud-card.svg",
    name: "Как устроена машина по созданию облаков?",
    delay: 0.25,
    img1: "/cards-page-img/cloud-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "Машина для создания облаков от NASA.",
      },
      {
        type: "paragraph",
        content:
          "Вы когда-нибудь слышали о <strong class='bold-word'>«машине для создания облаков»</strong> от NASA? Эта идея звучит захватывающе, но давайте разберемся, что на самом деле стоит за этой идеей!",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/cloud-img-2.jpg",
        title: "Откуда взялись слухи?",
        text: "Слухи о такой машине начали распространяться после появления в интернете видео с испытаниями мощного ракетного двигателя RS-25. Многие люди, увидев облака пара, подумали, что NASA разрабатывает технологии для создания облаков.",
      },
      {
        type: "media-block",
        direction: "column-reverse",
        img: "/cards-page-img/cloud-img-3.jpg",
        title: "На самом деле...",
        text: "Однако на самом деле это не что иное, как горячий водяной пар, который выделяется в результате сжигания жидкого водорода. Во время настоящего запуска ракеты пар поднимается вверх, следуя за ракетой, но на испытаниях он выходит из двигателя горизонтально, создавая эффект облаков. Это зрелище может быть впечатляющим, но оно не имеет ничего общего с созданием облаков в атмосфере.",
      },
      {
        type: "paragraph",
        content:
          "Таким образом, <strong class='bold-word'>«машина для создания облаков»</strong> от NASA — это всего лишь миф. Но было бы здорово иметь возможность создавать свои собственные облачка! Так что в следующий раз, когда вы увидите облака на небе, знайте, что они созданы природой, а не высокими технологиями.",
      },
      {
        type: "ending",
        content:
          "А вы бы хотели создать свое собственное облачко? Какое оно было бы — пушистым и белоснежным или темным и грозовым?",
      },
    ],
  },
  {
    id: "4ac6204b-8c14-4efe-ad15-ebc9f051f523",
    type: "fighter",
    img: "/cards-img/fighter-card.svg",
    name: "Как устроена посадка истребителя на авианосец?",
    delay: 0.3,
    img1: "/cards-page-img/fighter-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "Экстремальные условия посадки.",
      },
      {
        type: "paragraph",
        content:
          "Представьте: ночь, бурное море, авианосец длиной в три футбольных поля качается на волнах. Пилот истребителя, мчащегося со скоростью 250 км/ч, должен приземлиться в зоне шириной всего 30 метров. Ошибка в одну секунду – и он либо врежется в корму корабля, либо упадет в воду.",
      },
      {
        type: "title",
        content: "Почему посадка на авианосец сложнее чем на аэродром?",
      },
      {
        type: "paragraph",
        content:
          "Авианосец – это плавучий аэродром, но его длина в 10 раз меньше обычной взлетно-посадочной полосы. Пилоту нужно:",
      },
      {
        type: "list",
        style: "point",
        items: [
          "Попасть в узкую зону (ширина палубы – 30–40 м).",
          "Зацепиться за трос, иначе самолет упадет в океан.",
          "Остановиться за 2 секунды (на обычном аэродроме торможение занимает 500–1000 метров).",
        ],
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/fighter-img-2.jpg",
        title: "Коррекция курса пилота",
        text: "Перед посадкой пилот корректирует курс, используя оптические системы и команды офицера, который может отменить посадку в последний момент. Если самолет идет слишком высоко, он промахнется, а если слишком низко – врежется в корму.",
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/fighter-img-3.jpg",
        title: "Посадка на авианосец",
        text: "Главный элемент посадки – аэрофинишёр, система из 4 стальных тросов, натянутых поперёк палубы. Пилот цепляет трос специальным крюком, который поглощает энергию самолета и останавливает его за 100 метров. Если трос рвется, самолет может упасть в воду.",
      },
      {
        type: "title",
        content: "Аварийные ситуации и риски.",
      },
      {
        type: "paragraph",
        content:
          "Если пилот понимает, что не сможет зацепить трос, он уходит на новый заход, но если двигатель не успевает набрать мощность, самолет может упасть. 80% аварий на авианосцах происходят ночью, когда пилоты видят только огни палубы и темный океан.",
      },
      {
        type: "ending",
        content: "Смогли ли бы так?",
      },
    ],
  },
  {
    id: "18cdcffc-82ac-4446-846a-954718333b39",
    type: "metro",
    img: "/cards-img/metro-card.svg",
    name: "Как устроено депо метро?",
    delay: 0.35,
    img1: "/cards-page-img/metro-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "Как устроено депо метро.",
      },
      {
        type: "paragraph",
        content:
          "Вы когда-нибудь задумывались, куда уезжают поезда, когда станции закрываются и кто за ними следит? Давайте разбираться!",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/metro-img-3.jpg",
        title: "Что такое депо метро?",
        text: "Депо метро — это дом для поездов, а точнее, где они хранятся, обслуживаются и ремонтируются. Здесь работают механики, следящие за безопасностью и исправностью составов. Сюда же поступают более новые и комфортные составы.",
      },
      {
        type: "title",
        content: "Подземное и поверхностное депо.",
      },
      {
        type: "paragraph",
        content:
          "Подземные депо находятся ниже уровня земли и имеют сложные системы вентиляции и освещения. Они экономят пространство и защищают поезда от погодных условий. А вот Поверхностные депо проще в обслуживании и обеспечивают легкий доступ для работников. Они включают открытые площадки и ремонтные мастерские.",
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/metro-img-2.jpg",
        title: "Как поезда добираются до станций?",
        text: "Поезда выезжают из депо и отправляются на станцию. Время в пути зависит от расстояния и может занимать от нескольких минут до получаса.",
      },
      {
        type: "title",
        content: "Как поезда погружаются под землю?",
      },
      {
        type: "paragraph",
        content:
          "Если депо на поверхности, поезда используют наклонные пути (рампы) для спуска под землю, что особенно важно для глубоких станций в Санкт-Петербурге.",
      },
      {
        type: "ending",
        content: "Как вам такое?",
      },
    ],
  },
  {
    id: "53cfa9dc-a0da-4d16-acdb-067b8b0e2343",
    type: "money",
    img: "/cards-img/money-card.svg",
    name: "Как печатают деньги?",
    delay: 0.4,
    img1: "/cards-page-img/money-img-1.jpg",
    blocks: [
      {
        type: "title",
        content:
          "Как печатают деньги: секретный завод, где бумажки превращаются в богатство!",
      },
      {
        type: "paragraph",
        content:
          "Вы когда-нибудь задумывались, откуда берутся деньги? Их <strong class='bold-word'>печатают</strong> на сверхсекретных фабриках, где обычная бумага превращается в настоящие сокровища!",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/money-img-4.jpg",
        title: "Бумага? Да это же почти джинсы!",
        text: "Оказывается, деньги делают не из дерева, а из... <strong class='bold-word'>хлопка и льна</strong>! То есть твоя купюра — это, по сути, микроскопические штаны. В неё ещё добавляют:",
      },
      {
        type: "list",
        style: "point",
        items: [
          "<strong class='bold-word'>Невидимые нити</strong> (светятся в ультрафиолете, как диско-шар)",
          "<strong class='bold-word'>Водяные знаки</strong> (если посветить — увидите лицо какого-нибудь важного дяденьки)",
          "<strong class='bold-word'>Пластиковую ленту</strong> (чтобы даже после стирки в кармане джинсов деньги оставались целыми)",
        ],
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/money-img-3.jpg",
        title: "Печать: сначала красиво, потом — хитро",
        text: "Сначала деньги разрисовывают, как картину. Огромные станки за минуты штампуют <strong class='bold-word'>тысячи листов</strong> с узорами и цифрами. Краска тут не простая:",
      },
      {
        type: "list",
        style: "point",
        items: [
          "<strong class='bold-word'>Магнитная</strong> — её чувствуют банкоматы",
          "<strong class='bold-word'>Светящаяся</strong> — если посветить УФ-фонариком, купюра превращается в мини-дискотеку",
        ],
      },
      {
        type: "paragraph",
        content:
          "А потом <strong class='bold-word'>выдавливают рельеф</strong> — те самые шершавые линии, которые можно пощупать пальцами. Это делают <strong class='bold-word'>гигантские прессы</strong>, которые давят на бумагу с огромной силой!",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/money-img-2.jpg",
        title: "Где же этот денежный рай?",
        text: "В России печатью занимается <strong class='bold-word'>Гознак</strong>. В США — <strong class='bold-word'>Бюро гравировки и печати</strong>. Попасть туда сложнее, чем в Хогвартс — везде камеры, охрана и куча секретов.",
      },
      {
        type: "ending",
        content:
          "Теперь вы знаете больше, чем  99% людей! В следующий раз, когда достанете купюру, посмотрите на неё внимательно — вдруг найдёте что-то, чего раньше не замечали?",
      },
    ],
  },
  {
    id: "c30a01dc-d7e2-4cb9-acaa-4fa9bb782027",
    type: "mid-air-refueling",
    img: "/cards-img/plane-passenger-card.svg",
    name: "Как устроена заправка в воздухе?",
    delay: 0.05,
    img1: "/cards-page-img/mid-air refueling-img-2.jpg",
    blocks: [
      {
        type: "title",
        content: "Небо - не предел: как самолеты заправляются в полёте.",
      },
      {
        type: "paragraph",
        content:
          "Вы когда-нибудь задумывались, как огромные самолеты могут летать на тысячи километров, не приземляясь для дозаправки? Это не магия, а удивительная система воздушной заправки! Давайте разберёмся, как это работает и почему это так важно.",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/mid-air refueling-img-3.jpg",
        title: "Зачем нужна заправка в воздухе?",
        text: "Представьте, что военный истребитель должен пролететь 10 000 км, или пассажирский лайнер хочет сократить путь без остановок. Вот тут-то и приходят на помощь воздушные танкеры! Они позволяют:",
      },
      {
        type: "list",
        style: "point",
        items: [
          "<strong class='bold-word'>Военным</strong>: истребителям и бомбардировщикам достигать любой точки мира.",
          "<strong class='bold-word'>Гражданским</strong>: самолетам летать на длинные маршруты без лишних остановок.",
          "<strong class='bold-word'>Спасательным операциям</strong>: вертолетам работать дольше без посадки.",
        ],
      },
      {
        type: "title",
        content: "Как выглядит танкер?",
      },
      {
        type: "paragraph",
        content:
          "Танкер — это переоборудованный самолет, который вместо пассажиров или грузов вмещает огромные баки с топливом. Он может хранить до <strong class='bold-word'>160 000 литров</strong> горючего — это как три железнодорожные цистерны! Перед вылетом танкер заправляется в аэропорту, а затем поднимается в небо, готовый ко встрече с другими самолетами.",
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/mid-air refueling-img-1.jpg",
        title: "Как происходит заправка в воздухе?",
        text: "Когда два самолета встречаются в небе, это похоже на настоящий танец! На высоте 6-8 км они сближаются с точностью до сантиметров. Есть два основных способа заправки:",
      },
      {
        type: "list",
        style: "point",
        items: [
          "<strong class='bold-word'>Шланг-конус</strong>: танкер выпускает гибкий шланг с воронкой, и пилот принимающего самолета должен «поймать» её специальным штырем.",
          "<strong class='bold-word'>Штанга</strong>: оператор на танкере управляет жесткой трубой, которая стыкуется с люком принимающего самолета.",
          "Оба самолета должны держать идеальную скорость и курс, чтобы всё прошло гладко!",
        ],
      },
      {
        type: "list",
        style: "hand-point",
        customHeader: "<strong class='bold-word'>Интересные факты:</strong>",
        items: [
          "<strong class='bold-word'>Самый долгий полёт с дозаправками</strong>: 64 дня 22 часа (биплан Cessna 172 в 1958 году).",
          "<strong class='bold-word'>Рекорд скорости заправки</strong>: истребитель F-15 получил 7 тонн топлива за 5 минут.",
          "<strong class='bold-word'>Курьёз</strong>: в 1966 году танкер случайно заправил истребитель своим собственным топливом и был вынужден экстренно садиться!",
        ],
      },
      {
        type: "ending",
        content: "Смогли бы так?",
      },
    ],
  },
  {
    id: "e440a8ee-21d7-48ee-82f9-970a10ab176d",
    type: "breakfast",
    img: "/cards-img/breakfast-card.svg",
    name: "Как создают сухие завтраки?",
    delay: 0.1,
    img1: "/cards-page-img/breakfast-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "От зерна до хруста: как на заводе создают сухие завтраки.",
      },
      {
        type: "paragraph",
        content:
          "Представьте: вы открываете коробку с хрустящими кукурузными шариками, заливаете их молоком — и вот уже во рту они хрустят! Но задумывались ли вы, какой путь проходит этот завтрак от поля до вашей тарелки? Сегодня мы заглянем на секретный производственный конвейер, где зерно превращается в любимые хлопья, подушечки и звёздочки.",
      },
      {
        type: "title",
        content: "Приём сырья: с поля на фабрику.",
      },
      {
        type: "paragraph",
        content:
          "Всё начинается с <strong class='bold-word'>зерна</strong> — кукурузы, пшеницы, овса или риса. Грузовики привозят его на завод, где лаборанты тщательно проверяют качество. Зерно взвешивают на автоматических весах, очищают от мусора и проверяют металлодетекторами. Только самое лучшее зерно попадает в огромные металлические силосы для хранения. ",
      },
      {
        type: "media-block",
        direction: "column",
        img: "/cards-page-img/breakfast-img-2.jpg",
        title: "Варка и прессование",
        text: "Зерно попадает в <strong class='bold-word'>варочные котлы</strong>, где его смешивают с водой, солью и иногда сахаром. Получается густая масса, похожая на тесто.",
      },
      {
        type: "paragraph",
        content:
          "Для создания разных форм используют специальные машины. Экструдер (машина, которая продавливает тесто через специальные отверстия) выдавливает тесто через отверстия, получая подушечки и шарики. Затем станок раскатывает массу в тонкие пласты для хлопьев. За этим процессом внимательно следят операторы, регулируя температуру и давление.",
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/breakfast-img-3.jpg",
        title: "Сушка и обжарка: от мягкой массы к хрусту",
        text: "Сырые заготовки отправляются в <strong class='bold-word'>огромные печи</strong>, где их обдувают горячим воздухом. В этот момент происходит <strong class='bold-word'>магия</strong>: влага испаряется, а продукт становится хрустящим.",
      },
      {
        type: "list",
        style: "hand-point",
        customHeader:
          "<strong class='bold-word'>Глазировка и добавки: вкусный финальный штрих</strong>",
        items: [
          "<strong class='bold-word'>Распылители</strong> наносят тонкий слой сахарного сиропа или шоколада.",
          "<strong class='bold-word'>Барабанные смесители</strong> обваливают хлопья в корице, какао или витаминной смеси.",
        ],
      },
      {
        type: "list",
        style: "hand-point",
        customHeader: "<strong class='bold-word'>Что делает техника?</strong>",
        items: [
          "<strong class='bold-word'>Дозаторы</strong> насыпают точное количество хлопьев в пакет",
          "<strong class='bold-word'>Газовые камеры</strong> заполняют упаковку азотом, чтобы завтрак не отсырел.",
          "<strong class='bold-word'>Роботы-укладчики</strong> ставят коробки на подносы.",
        ],
      },
      {
        type: "ending",
        content: "Поработали бы там? ",
      },
    ],
  },
  {
    id: "66c635fd-e4ae-4301-a616-ea647b7e48a3",
    type: "baggage",
    img: "/cards-img/baggage-card.svg",
    name: "Как устроен маршрут вашего чемодана?",
    delay: 0.2,
    img1: "/cards-page-img/baggage-img-4.png",
    blocks: [
      {
        type: "title",
        content: "Тайная жизнь вашего чемодана от стойки до ленты.",
      },
      {
        type: "paragraph",
        content:
          "Вы сдали чемодан и думаете, что он просто едет по конвейеру и загружается в самолет? Как бы не так! Ваш багаж отправляется в крутое приключение по тайным уголкам аэропорта, где с ним происходят вещи, о которых вы даже не догадываетесь.",
      },
      {
        type: "title",
        content: "Прощание на стойке регистрации: начало квеста.",
      },
      {
        type: "paragraph",
        content:
          "Вы только что отдали чемодан, и он исчезает за занавеской. <strong class='bold-word'>Что дальше?</strong> <br />Дальше медленная конвейерная лента везёт ваш багаж мимо грустных сотрудников, которые уже видели миллион таких же чемоданов. И затем сканер проверяет не везёте ли вы, например кота в коробке. ",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/baggage-img-2.jpg",
        title: "Сортировочный центр",
        text: "Теперь ваш чемодан попадает в страну чемоданов – огромный автоматизированный лабиринт, где их сортируют и отправляют в самолёт.",
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/baggage-img-4.jpg",
        title: "Что здесь происходит?",
        text: "На всём протяжении транспортной ленты установлены считывающие устройства, которые распознают бирку и перенаправляют груз по заданному маршруту. А если чемодан с устаревшей биркой на этом этапе отправляется на повторную обработку.",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/baggage-img-1.jpg",
        title: "Погрузка в самолет",
        text: "После этого сотрудники сортировочной службы забирают багаж и повторно сканируют его бирку. Это позволяет системе зафиксировать прохождение данного этапа, упрощая дальнейшее отслеживание в случае утери. Затем чемоданы доставляют к самолёту и помещают на борт.",
      },
      {
        type: "title",
        content: "Прибытие, или где мой чемодан, Карл?!",
      },
      {
        type: "paragraph",
        content:
          "Наконец, самолет приземлился! Вы бежите к ленте выдачи багажа, но вашего чемодана нет… И только через <strong class='bold-word'>20 минут</strong>, когда вы уже мысленно попрощались со своими вещами, ваш чемодан выезжает последним…",
      },
      {
        type: "list",
        style: "hand-point",
        customHeader: "<strong class='bold-word'>Как этого избежать?</strong>",
        items: [
          "Сдавайте свой чемодан последним и его загрузят последним, а ещё <strong class='bold-word'>клейте бирки</strong> так, будто от этого зависит жизнь вашего чемодана (потому что так и есть).",
        ],
      },
      {
        type: "ending",
        content: "А у вас приезжал чемодан первый?",
      },
    ],
  },
  {
    id: "201b8d19-8a0a-49cc-8bbf-4eab0f25c463",
    type: "pigone",
    img: "/cards-img/pigone-card.svg",
    name: "Как голуби доставляют почту?",
    delay: 0.3,
    img1: "/cards-page-img/pigone-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "Как голуби доставляют почту?",
      },
      {
        type: "paragraph",
        content:
          "Представьте себе мир, где сообщения передаются не по проводам и не через интернет, а с помощью удивительных птиц — почтовых голубей. Эти пернатые курьеры, обладая уникальными способностями, на протяжении тысячелетий служили связующим звеном между людьми, доставляя важные сообщения на большие расстояния.",
      },
      {
        type: "title",
        content: "Как голуби понимают, куда лететь?",
      },
      {
        type: "paragraph",
        content:
          "Почтовые голуби обладают удивительным чувством направления, которое позволяет им находить дорогу домой, даже если они находятся на значительном расстоянии. Это происходит благодаря их способности запоминать местность и использовать солнечные и магнитные ориентиры. Когда голубь отправляется в путь, он не просто летит в случайном направлении — он точно знает, как вернуться к своему гнезду. Это делает их идеальными для доставки сообщений, особенно в условиях, когда другие способы связи были недоступны.",
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/pigone-img-3.jpg",
        title: "Какие голуби могут доставлять почту?",
        text: "Не все голуби подходят для роли почтовых курьеров. Наиболее известными являются голуби породы <strong class='bold-word'>«голубь-секретарь»</strong> и <strong class='bold-word'>«голубь-спортсмен»</strong>.",
      },
      {
        type: "paragraph",
        content:
          "Эти птицы обладают выдающимися способностями к навигации и высокой скоростью полета. В то же время, обычные городские голуби не имеют таких навыков и не могут эффективно выполнять почтовые функции.",
      },
      {
        type: "ending",
        content: "Хотели бы себе такого почтальона?",
      },
    ],
  },
  {
    id: "b9c32348-6577-466f-8d2b-3a5bfcb9da45",
    type: "fireball",
    img: "/cards-img/fireball-card.svg",
    name: "Что такое шаровая молния?",
    delay: 0.35,
    img1: "/cards-page-img/fireball-img-1.jpg",
    blocks: [
      {
        type: "title",
        content: "Шаровая молния: Загадка, которая завораживает.",
      },
      {
        type: "paragraph",
        content:
          "Представьте: гроза, яркие молнии, и вдруг — в воздухе появляется светящийся шар, медленно скользящий, как будто живой. Это шаровая молния — одно из самых таинственных явлений природы, которое до сих пор интригует ученых и простых людей.",
      },
      {
        type: "media-block",
        direction: "row",
        img: "/cards-page-img/fireball-img-3.jpg",
        title: "Что это такое?",
        text: "Шаровая молния — это светящийся шар, который может свободно перемещаться в воздухе, часто возникающий во время грозы. Ее размеры и цвета варьируются, и каждое появление — это уникальное и опасное зрелище.",
      },
      {
        type: "media-block",
        direction: "row-reverse",
        img: "/cards-page-img/fireball-img-2.jpg",
        title: "Как она появляется?",
        text: "Существует множество теорий о ее происхождении. Некоторые ученые считают, что шаровая молния возникает из-за взаимодействия молний с атмосферой, создавая плазменные образования. Другие связывают ее с химическими реакциями или электромагнитными полями.",
      },
      {
        type: "list",
        style: "hand-point",
        customHeader: "<strong class='bold-word'>Мифы и легенды:</strong>",
        items: [
          "<strong class='bold-word'>Антивещество из космоса:</strong> Некоторые люди считают, что шаровая молния — это нечто инопланетное или антивещество, пришедшее из космоса. Научные исследования не подтверждают эту теорию.",
          "<strong class='bold-word'>Проходит сквозь стены:</strong> Существует мнение, что шаровая молния при соприкосновении с стеной может прожечь или взорвать её. На самом деле, она может взаимодействовать с окружающими предметами, но не обладает магическими свойствами.",
          "<strong class='bold-word'>Живое существо:</strong> Некоторые люди описывают шаровую молнию как нечто живое, что может двигаться по своему усмотрению. Но научные исследования показывают обратное.",
        ],
      },
      {
        type: "paragraph",
        content:
          "Эти мифы подчеркивают, насколько загадочной остается шаровая молния, и как легко люди могут придавать ей мистические свойства. ",
      },
      {
        type: "ending",
        content: "Посмотрели бы на такое зрелище?",
      },
    ],
  },
];
